import { factorType } from "../Utils/Analytics/tagType";
export { loadDynamicScripts } from "./loadDynamicScripts";
export { getUrlParams } from "./getUrlParams";

export function isCnpj(value) {
  return value && value.length >= 14;
}

export function isValidEmail(email = "") {
  const [, nxDomain = ""] = email.split("@");
  const email_match = email.match(
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  const duplicated_nx_domains = nxDomain.match(/\b(\.\w+)\b(?=.*?\b\1\b)/);
  return !!email_match && !duplicated_nx_domains;
}

export function isNullOrBlank(data) {
  return (data === null || data === undefined || data === "" ) 
}

export function isProd() {
  return process.env.REACT_APP_AMBIENTE === "production"||process.env.REACT_APP_AMBIENTE === "staging"||process.env.REACT_APP_AMBIENTE === "qa"
}

export function urlCallbackValidation(value) {
  if(isNullOrBlank(value) ){
    value =  process.env.REACT_APP_MY_PROFILE_URL
  }
  
  return value;
}

export function isTwoFactor(loginEmail,loginPhoneNumber) {

  if(!isNullOrBlank(loginEmail) && !isNullOrBlank(loginPhoneNumber) ){
    return factorType.TWO_FACTOR
  }
  else{
    return factorType.ONE_FACTOR
  }
}
